import React from 'react';

const Inventory = () => {
    return (
        <div className="min-h-screen bg-gray-900">
            <iframe 
                // src="/bestseller_table copy 2.html" 
                src="/warehouse_inventory.html" 
                title="Warehouse Inventory"
                className="w-full h-screen"
                style={{ border: 'none' }}
            />
        </div>
    );
};

export default Inventory;

